import { gql } from '@apollo/client';

const PriceBookInfo = gql`
  fragment PriceBookInfo on PriceBook {
    id
    name
    description
    adminLocationId
    partnerLocations {
      id
      name
      phone
      email
      website
      address {
        id
        address
        city
        region
      }
      imageUrl
    }
    priceBookProductsAttributes {
      id
      price
      wholesalePrice
      showInStore
      overPrice
      overrideWholesalePrice
      productId
      product {
        id
        name
        internalName
        isEot
        price
        wholesalePrice
        productCategories {
          id
          name
        }
      }
    }
    createdAt
    updatedAt
  }
`;

export default PriceBookInfo;
